import React from 'react';
import styled from 'styled-components';
import ImageGallery from './ImageGallery';
import entradaUsinaImg from '../assets/images/entrada-usina.jpeg';
import usinaBaiasImg from '../assets/images/usina-baias.jpeg';
import usinaDeCimaImg from '../assets/images/usina-de-cima.jpeg';
import separacaoImg from '../assets/images/separacao.jpeg';
import comerImg from '../assets/images/comer.jpeg';

const Section = styled.section`
  padding: 8rem 1rem 4rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`;

const Description = styled.p`
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
  line-height: 1.6;
  color: #666;
`;

const ProcessFlow = styled.div`
  margin: 4rem 0;
`;

const ProcessTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`;

const ProcessGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
`;

const ProcessCard = styled.div`
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const ProcessCardTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
`;

const ProcessCardDescription = styled.p`
  color: #666;
  line-height: 1.5;
`;

const BenefitsSection = styled.div`
  margin: 4rem 0;
`;

const BenefitsTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
`;

const BenefitCard = styled.div`
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const BenefitTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
`;

const BenefitDescription = styled.p`
  color: #666;
  line-height: 1.5;
`;

const SocialImpactSection = styled.div`
  margin: 4rem 0;
`;

const SocialImpactTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
`;

const ImpactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
`;

const ImpactCard = styled.div`
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const ImpactTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
`;

const ImpactDescription = styled.p`
  color: #666;
  line-height: 1.5;
`;

const facilityImages = [
  {
    url: entradaUsinaImg,
    caption: "Instalações Modernas da Usina Cidade Limpa"
  },
  {
    url: usinaBaiasImg,
    caption: "Área de Compostagem Controlada"
  },
  {
    url: usinaDeCimaImg,
    caption: "Centro de Recuperação de Materiais"
  },
  {
    url: separacaoImg,
    caption: "Impacto Social e Geração de Empregos"
  },
  {
    url: comerImg,
    caption: "Programas de Educação Ambiental"
  }
];

const processImages = [
  {
    url: separacaoImg,
    caption: "Linha de Triagem Automatizada"
  },
  {
    url: usinaBaiasImg,
    caption: "Processo de Compostagem"
  },
  {
    url: usinaDeCimaImg,
    caption: "Produtos Sustentáveis"
  }
];

const UsinaCidadeLimpa = () => {
  return (
    <Section>
      <Title>Usina Cidade Limpa</Title>
      <Description>
        Solução completa e integrada para o tratamento de resíduos urbanos, combinando tecnologia avançada, 
        responsabilidade ambiental e impacto social positivo para transformar o problema do lixo em oportunidade 
        de desenvolvimento sustentável.
      </Description>

      <ImageGallery 
        title="Instalações e Processos" 
        images={facilityImages} 
      />

      <ProcessFlow>
        <ProcessTitle>Processo Integrado</ProcessTitle>
        <ProcessGrid>
          <ProcessCard>
            <ProcessCardTitle>Recepção e Triagem</ProcessCardTitle>
            <ProcessCardDescription>
              Os resíduos urbanos chegam à usina e são descarregados em uma área de recepção. Uma equipe, junto a 
              esteiras automatizadas, realiza a triagem inicial, separando materiais recicláveis, orgânicos e rejeitos.
            </ProcessCardDescription>
          </ProcessCard>
          <ProcessCard>
            <ProcessCardTitle>Compostagem Assistida</ProcessCardTitle>
            <ProcessCardDescription>
              Resíduos orgânicos são direcionados às baias de compostagem, onde passam por um processo aeróbico 
              controlado de 20-30 dias, transformando o lixo orgânico em composto rico em nutrientes.
            </ProcessCardDescription>
          </ProcessCard>
          <ProcessCard>
            <ProcessCardTitle>Tratamento com MAQ-RSU</ProcessCardTitle>
            <ProcessCardDescription>
              Os rejeitos secos e materiais não orgânicos são processados pelo sistema MAQ-RSU, que realiza a 
              separação, trituração, secagem e queima em alta temperatura, com tratamento completo de gases.
            </ProcessCardDescription>
          </ProcessCard>
          <ProcessCard>
            <ProcessCardTitle>Produção de Materiais</ProcessCardTitle>
            <ProcessCardDescription>
              As cinzas do processo são transformadas em pavers e tijolos ecológicos, enquanto o composto orgânico 
              é utilizado em jardins, hortas e áreas públicas, fechando o ciclo da economia circular.
            </ProcessCardDescription>
          </ProcessCard>
        </ProcessGrid>
      </ProcessFlow>

      <ImageGallery 
        title="Etapas do Processo" 
        images={processImages} 
      />

      <BenefitsSection>
        <BenefitsTitle>Benefícios</BenefitsTitle>
        <BenefitsGrid>
          <BenefitCard>
            <BenefitTitle>Ambiental</BenefitTitle>
            <BenefitDescription>
              Redução significativa do uso de aterros e lixões, diminuição da contaminação do solo e água, 
              e menor emissão de gases de efeito estufa.
            </BenefitDescription>
          </BenefitCard>
          <BenefitCard>
            <BenefitTitle>Econômico</BenefitTitle>
            <BenefitDescription>
              Geração de receita através da comercialização de materiais recicláveis, composto orgânico 
              e produtos sustentáveis.
            </BenefitDescription>
          </BenefitCard>
          <BenefitCard>
            <BenefitTitle>Social</BenefitTitle>
            <BenefitDescription>
              Criação de empregos formais, melhoria das condições de trabalho e desenvolvimento de 
              programas de educação ambiental.
            </BenefitDescription>
          </BenefitCard>
        </BenefitsGrid>
      </BenefitsSection>

      <SocialImpactSection>
        <SocialImpactTitle>Impacto Social</SocialImpactTitle>
        <ImpactGrid>
          <ImpactCard>
            <ImpactTitle>Geração de Empregos</ImpactTitle>
            <ImpactDescription>
              Aumento de 500% em vagas de empregos formalizados em comparação com mão de obra em aterros.
            </ImpactDescription>
          </ImpactCard>
          <ImpactCard>
            <ImpactTitle>Educação Ambiental</ImpactTitle>
            <ImpactDescription>
              Programas de conscientização e treinamento para escolas, instituições e comunidade local.
            </ImpactDescription>
          </ImpactCard>
          <ImpactCard>
            <ImpactTitle>Obras Públicas</ImpactTitle>
            <ImpactDescription>
              Utilização dos materiais produzidos em obras de infraestrutura local, como calçadas, 
              praças e pavimentação.
            </ImpactDescription>
          </ImpactCard>
        </ImpactGrid>
      </SocialImpactSection>
    </Section>
  );
};

export default UsinaCidadeLimpa;
